<div class="card-app-white">
  <form [formGroup]="form" appPermissionControl="P103F0001">
    <div class="card-header">
      <div class="title-section">
        <h5 class="header-title">{{ modelRecived ? 'Editar' : 'Nueva' }} Empresa Afiliada</h5>
      </div>
      <div class="button-section">
        <button
          mat-flat-button
          (click)="modelRecived ? update(form.value) : create(form.value)"
          class="{{ modelRecived ? 'btn-edit' : 'btn-success' }}"
          [disabled]="!form.valid"
          appPermissionControl="P103B0001"
        >
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P103B0002">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>
    <br />
    <hr />
    <br />

    <div class="form-row">
      <!-- CLAVE -->
      <div class="form-field">
        <input
          type="text"
          maxlength="4"
          formControlName="sEmpresa"
          class="form-control"
          placeholder="Ingrese clave (máx. 4 caracteres)"
          [ngClass]="{ invalid: form.controls['sEmpresa'].invalid && form.controls['sEmpresa'].touched }"
          appPermissionControl="P103K0001"
        />
        <label>Clave *</label>
      </div>

      <!-- CIUDAD -->
      <div class="form-field">
        <input type="text" formControlName="ciudad" class="form-control" placeholder="Ingrese Ciudad" appPermissionControl="P103K0002" />
        <label>Ciudad</label>
      </div>

      <!-- EMPRESA -->
      <div class="form-field">
        <input
          type="text"
          formControlName="sNombre"
          class="form-control"
          placeholder="Ingrese Empresa"
          [ngClass]="{ invalid: form.controls['sNombre'].invalid && form.controls['sNombre'].touched }"
          appPermissionControl="P103K0003"
        />
        <label>Empresa *</label>
      </div>

      <!-- ESTADO -->
      <div class="form-field">
        <select formControlName="cve_Estado" class="form-control" appPermissionControl="P103K0004">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let estado of listcve_Estado" [value]="estado.sOpcion">
            {{ estado.sOpcion }}
          </option>
        </select>
        <label>Estado</label>
      </div>

      <!-- TIPO -->
      <div class="form-field">
        <select formControlName="sTipo" class="form-control" appPermissionControl="P103K0006">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let tipo of listcve_Tipo" [value]="tipo.sOpcion">
            {{ tipo.sOpcion }}
          </option>
        </select>
        <label>Tipo</label>
      </div>

      <!-- COLONIA -->
      <div class="form-field">
        <input type="text" formControlName="colonia" class="form-control" placeholder="Ingrese Colonia" appPermissionControl="P103K0008" />
        <label>Colonia</label>
      </div>

      <!-- RESPONSABLE -->
      <div class="form-field">
        <input type="text" formControlName="responsable" class="form-control" placeholder="Ingrese Responsable" appPermissionControl="P103K0009" />
        <label>Responsable</label>
      </div>

      <!-- DIRECCIÓN -->
      <div class="form-field">
        <input type="text" formControlName="calle" class="form-control" placeholder="Ingrese Dirección" appPermissionControl="P103K0010" />
        <label>Dirección</label>
      </div>

      <!-- TELEFONO -->
      <div class="form-field">
        <input type="number" formControlName="telefono" class="form-control" placeholder="Ingrese teléfono principal" appPermissionControl="P103K0011" />
        <label>Teléfono</label>
      </div>

      <!-- CÓDIGO POSTAL -->
      <div class="form-field">
        <input type="number" formControlName="cp" class="form-control" placeholder="ej. 660663" appPermissionControl="P103K0012" />
        <label>Código Postal</label>
      </div>

      <!-- EMAIL -->
      <div class="form-field">
        <input
          type="email"
          [ngClass]="{ invalid: form.controls['del_Mun'].invalid && form.controls['del_Mun'].touched }"
          formControlName="del_Mun"
          class="form-control"
          placeholder="ej. correo@prueba.com"
          appPermissionControl="P103K0013"
        />
        <label>e-Mail</label>
      </div>
    </div>

    <br />
    <br />
    <div class="button-section" *ngIf="modelRecived">
      <button mat-stroked-button (click)="customizables()" class="btn-search" appPermissionControl="P103B0003">
        <mat-icon aria-hidden="false" aria-label="Domicilios" class="icon-btn">receipt</mat-icon>
        Customizables
      </button>
      <button mat-stroked-button (click)="openSucursales()" class="btn-edit" appPermissionControl="P103B0004">
        <mat-icon aria-hidden="false" aria-label="Sucursales" class="icon-btn">store</mat-icon>
        Sucursales
      </button>
      <button mat-stroked-button (click)="cuentas()" class="btn-cancel" appPermissionControl="P103B0005">
        <mat-icon aria-hidden="false" aria-label="Domicilios" class="icon-btn">import_contacts</mat-icon>
        Cuentas
      </button>
    </div>
  </form>
</div>
